import PageWrapper from "../../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import { CardSpg } from "@duosoftbg/nacid-components";
import { CardContent } from "@mui/material";
import AdminConsoleConfig from "../../../components/admin/console/config/AdminConsoleConfig";

const AdminConsoleManagement = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.admin.console.config")}>
      <CardSpg my={4} style={{ overflow: "visible" }}>
        <CardContent style={{ padding: 24, position: "relative" }}>
          <AdminConsoleConfig />
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};

export default AdminConsoleManagement;
